'use strict';

import React from 'react';
import { Modal, Alert } from 'react-bootstrap';
import Cookies from 'js-cookie'
import InputField from './InputField.js'
import FaClose from 'react-icons/lib/fa/close'

class ContactForm extends React.Component {
  constructor(props) {
    super(props);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.closeAndSubmit = this.closeAndSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSuccessDismiss = this.handleSuccessDismiss.bind(this);
    this.handleErrorDismiss = this.handleErrorDismiss.bind(this);
    this.classes = this.classes.bind(this);
    
    this.state = {
      showModal: false,
      name: '',
      email: '',
      message: '',
      successVisible: false,
      errorVisible: false
    }
  }

  handleSuccessDismiss() {
    this.setState({
      successVisible: false
    })
  }

  handleErrorDismiss() {
    this.setState({
      errorVisible: false
    })
  }

  clearForm() {
    this.setState({
      name: '',
      email: '',
      message: ''
    })
  }

  // componentWillMount() {
  //   this.setState({ showModal: false });
  // }

  close() {
    this.setState({ showModal: false });
  }

  closeAndSubmit() {
    this.setState({ showModal: false });
    let csrftoken = Cookies.get('csrftoken');
    fetch('/api/v1/contact/', {
      method: 'POST',
      headers: {
        // 'Accept': 'application/json',
        // 'Content-Type': 'application/json',
        'X-CSRFToken': csrftoken
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        name: this.state.name,
        email: this.state.email,
        message: this.state.message
      })
    })
    .then(response => {
      if (response.ok) {
        this.setState({ successVisible: true })
        setTimeout(function() {
          this.setState({
            successVisible: false
          });
        }.bind(this), 5000);
        this.clearForm();
      } else {
        this.setState({ errorVisible: true })
        setTimeout(function() { this.setState({errorVisible: false}); }.bind(this), 5000);
      }
    })
    .catch(() => {
      this.setState({ errorVisible: true })
      setTimeout(function() { this.setState({errorVisible: false}); }.bind(this), 5000);
    })
  }

  open() {
    this.setState({ showModal: !this.state.showModal });
  }

  classes() {
    return `contact-form ${this.state.showModal ? 'visible' : ''}`;
  }

  handleInputChange(event) {
    const target = event.target;
    const name = target.name;

    this.setState({
      [name]: target.value
    });
  }

  render() {
    /*const popover = (
      <Popover id="modal-popover" title="popover">
        very popover. such engagement
      </Popover>
    );
    const tooltip = (
      <Tooltip id="modal-tooltip">
        wow.
      </Tooltip>
    );*/

    return (
      <div>
        <div className={this.classes()}>
          <button
            className="toggle-button"
            onClick={this.open}>
            Toc To Me
            <img src="/static/images/comment.svg" />
          </button>
          <div className="body">
            <button className="close-button" onClick={this.close}><FaClose /></button>
            <div className="site__form">
              <InputField name="name" value={this.state.name} onChange={this.handleInputChange} type="text" label="Nome" errorMessage="Este campo é obrigatório"/>
              <InputField name="email" value={this.state.email} onChange={this.handleInputChange} type="email" label="Email" errorMessage="Introduza um endereço de e-mail válido"/>
              <InputField name="message" value={this.state.message} onChange={this.handleInputChange} type="area" rows="10" label="Mensagem" errorMessage="Este campo é obrigatório"/>
              <button onClick={this.closeAndSubmit}>Submeter</button>
            </div>
          </div>
        </div>
        {/* <Modal show={this.state.showModal} onHide={this.close}>
          <Modal.Header closeButton>
            <Modal.Title>Contacte-nos</Modal.Title>
          </Modal.Header> */}

        {/* </Modal> */}
        {this.state.successVisible &&
          <Alert bsStyle="success" onDismiss={this.handleSuccessDismiss}>
            <p>A sua mensagem foi enviada com sucesso.</p>
          </Alert>
        }
        {this.state.errorVisible &&
          <Alert bsStyle="danger" onDismiss={this.handleErrorDismiss}>
            <p>Ocorreu um erro, por favor tente novamente.</p>
          </Alert>
        }
      </div>
    );
  }
}

ContactForm.displayName = 'ContactForm';

// Uncomment properties you need
// ContactForm.propTypes = {};
// ContactForm.defaultProps = {};

export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/ContactForm.js